export class DsuAssessmentModel {

    private onboardingid!: number;
    private remarkid!: number;
    private dsuName!: string;
    private declaration_date!: string;
    private is_completed!: boolean;
    private remarkContent!: string;
    private updatedbyrole!: string;
    private corporatEmailAddress!:string;
    private return_comments!:string;


    constructor() { }

    // Getters & Setters
    getOnboardingid(): number {
        return this.onboardingid;
    }
    setOnboardingid(onboardingid: number) {
        this.onboardingid = onboardingid;
    }

    getRemarkId(): number {
        return this.remarkid;
    }
    setRemarkId(remarkid: number) {
        this.remarkid = remarkid;
    }

    getCorporatEmailAddress(): string {
        return this.corporatEmailAddress;
    }
    setCorporatEmailAddress(corporatEmailAddress: string) {
        this.corporatEmailAddress = corporatEmailAddress;
    }

    getDdsuName(): string {
        return this.dsuName;
    }
    setDsuName(dsuName: string) {
        this.dsuName = dsuName;
    }

    getDeclaration_date(): string {
        return this.declaration_date;
    }
    setDeclaration_date(declaration_date: string) {
        this.declaration_date = declaration_date;
    }

    getIs_completed(): boolean {
        return this.is_completed;
    }

    setIs_completed(is_completed: boolean) {
        this.is_completed = is_completed;
    }

    getRemarkContent(): string {
        return this.remarkContent;
    }
    setRemarkContent(remarkContent: string) {
        this.remarkContent = remarkContent;
    }

    getupdatedbyrole(): string {
        return this.updatedbyrole;
    }
    setupdatedbyrole(updatedbyrole: string) {
        this.updatedbyrole = updatedbyrole;
    }

    getReturnComments(): string {
        return this.return_comments;
    }
    setReturnComments(return_comments: string) {
        this.return_comments = return_comments;
    }



    toString() {
        return JSON.stringify({
            onboarding_id: this.getOnboardingid(),
            remarkid: this.getRemarkId(),
            corporate_email_adddress:this.getCorporatEmailAddress(),
            dsu_name: this.getDdsuName(),
            declaration_date: this.getDeclaration_date(),
            is_completed: this.getIs_completed(),
            remarkContent: this.getRemarkContent(),
            updated_by_role: this.getupdatedbyrole(),
            return_comments:this.getReturnComments()
        });
    }


}
